import React, { useEffect, useRef, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import Select from "react-select";
import { trackEvent } from "../helpers/trackEvent";

const options = [
  { value: "text", label: "Text" },
  { value: "qrCode", label: "QR code" },
  { value: "barcode39", label: "Barcode 39" },
  { value: "barcode128", label: "Barcode 128" },
];

const NewFieldDialog = ({ open, fields, handleClose, handleAdd }) => {
  const [type, setType] = useState("text");
  const [value, setValue] = useState("");

  const isValid =
    value?.trim() &&
    !Object.keys(fields).find((label) => label === value.trim());

  const inputRef = useRef(null);

  const handleEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    setType("text");
    setValue("");
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEnforceFocus
      TransitionProps={{
        onEntered: handleEntered,
      }}
    >
      <DialogContent>
        <h3 className="dialog-title">Add attendee info field</h3>
        <div className="dialog-description">
          Enter a field name – it must not duplicate any existing field names
        </div>
        <TextField
          margin="dense"
          label="Field name"
          type="text"
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          inputRef={inputRef}
          error={value?.trim() && !isValid}
          helperText={
            value?.trim() && !isValid ? "This field already exists" : ""
          }
          InputLabelProps={{
            error: value?.trim() && !isValid,
          }}
        />
        <Select
          options={options}
          value={options.find((option) => option.value === type)}
          onChange={({ value }) => setType(value)}
          placeholder="Select type of field"
          className="code-type-select"
        />
      </DialogContent>
      <DialogActions>
        <button className="button" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="primary"
          disabled={!isValid}
          onClick={() => {
            if (isValid) {
              handleAdd({ value, type });
              trackEvent({
                action: 'add_field', data: {
                  addedFieldType: type
                }
              })
            }
          }}
        >
          Add field
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default NewFieldDialog;
